"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Button_1 = __importDefault(require("../../Util/Button"));
const Icon_1 = __importDefault(require("../../Util/Icon"));
const NavContext_1 = __importDefault(require("../../../contexts/NavContext"));
const withJourney_1 = __importDefault(require("../../../hocs/withJourney"));
const Journey_1 = require("../../../lib/Journey");
const DrawerToggleButton = (props) => {
    const { drawerOpen, setDrawerOpen } = react_1.useContext(NavContext_1.default);
    return (react_1.default.createElement(Button_1.default, Object.assign({}, props, { onClick: () => setDrawerOpen(!drawerOpen) }),
        react_1.default.createElement(Icon_1.default, { src: drawerOpen ? Journey_1.Journey.icons().CLOSE : Journey_1.Journey.icons().MENU })));
};
exports.default = withJourney_1.default('j-drawer-toggle-button', DrawerToggleButton);
